var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"pt-3":""}},[_c('v-flex',{attrs:{"xs1":""}}),_c('v-flex',{staticClass:"mysymptoms-main-container",attrs:{"xs10":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.docBody)}})]),_c('v-flex',{attrs:{"xs1":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }